import {InjectionToken} from "@angular/core";
import {ILanguageStateService} from "@zaeper/localization-lib";

export const languageStateServiceInjectionToken: InjectionToken<ILanguageStateService> = new InjectionToken<ILanguageStateService>("user-authentication-web.LanguageStateService");
